export const useSearchParams = (key) => {
  if (typeof window === 'undefined') {
    return { filter: '' };
  }
  const params = new URLSearchParams(window.location.search);
  return params.get(key) ?? '';
};
